import { Avatar } from "baseui/avatar";
import useGetAvatarColor from "../../hooks/useGetAvatarColor/useGetAvatarColor";

export const ColoredAvatar = (props) => {
  const userColor = useGetAvatarColor(props.username);

  const overrides = {
    ...props.overrides,
    ...{
      Root: {
        style: ({ $theme }) => ({
          backgroundColor: userColor,
        }),
      },
    },
  };

  return <Avatar name={props.username} {...props} overrides={overrides} />;
};
